import { render, staticRenderFns } from "./NowItem.vue?vue&type=template&id=0d13f0f0"
import script from "./NowItem.vue?vue&type=script&lang=js"
export * from "./NowItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports